<!--  leading-[calc(1.75rem+1px)] is used to visually align it on mobile-->
<template>
  <WLLink
    ref="elRef"
    class="wl-segment-block text-muted focus-visible:border-accent flex h-7 max-w-full cursor-pointer items-center rounded-md border border-solid border-transparent text-center text-sm leading-[calc(1.75rem+1px)] font-medium transition duration-150 outline-none md:leading-none"
    :to="to"
    :class="classes"
    @click="emit('click', $event)"
    @mouseenter="hasHover = !isDisabled"
    @mouseleave="hasHover = false"
  >
    <template v-if="icon">
      <WLIcon
        :name="icon"
        class="color-alt2"
        :class="{ 'text-accent': isActive }"
      />
    </template>
    <span
      v-else
      class="whitespace-nowrap select-none"
      :class="{ 'text-accent': isActive }"
    >
      {{ label }}
    </span>
  </WLLink>
</template>

<script lang="ts" setup generic="T extends string | number | boolean">
import { WLLink } from "../link";
import { WLIcon } from "../icon";
import { ref, useTemplateRef, computed } from "vue";
import type { SegmentBlockProps, SegmentBlockEmits } from "./types";

const { icon, isActive, isDisabled, label } =
  defineProps<SegmentBlockProps<T>>();
const emit = defineEmits<SegmentBlockEmits>();

const hasHover = ref(false);
const elRef = useTemplateRef("elRef");

const classes = computed(() => [
  { "has-hover": hasHover?.value },
  { "is-icon": icon },
  { "is-disabled": isDisabled },
  { "is-active": isActive },
]);

defineExpose({ elRef });
</script>

<style>
@reference "@theme";

.wl-segment-block {
  @apply px-3 py-2;

  &.is-disabled {
    @apply cursor-not-allowed opacity-50;
  }

  &.has-hover {
    @apply text-emphasis relative;
  }

  &.is-icon {
    @apply aspect-square h-auto justify-center px-1;
  }

  &.is-icon {
    @apply aspect-square h-auto w-7 justify-center px-1;

    .icon-wrapper {
      @apply size-5;

      &::before {
        @apply hidden;
      }
    }
  }
}
</style>
